import React from 'react'
import MainFile from './components/MainFile'

function ChangePassword() {
  return (
    <div>
      <MainFile/>
    </div>
  )
}

export default ChangePassword
